import React from "react";
import moment from "moment";
import "moment/locale/ja";
import styles from "./FromNow.module.scss";
import FormatType from "../../../models/date";

interface FromNowProps {
  date: string | null | undefined;
}

const FromNow: React.FC<FromNowProps> = ({ date }) => {
  const displayTime = (dateTime: string) => {
    const now = Date.now();
    const dateTimeStart = parseInt(dateTime, 10);
    const compareDate = moment(now).diff(moment(dateTimeStart), "days");
    return compareDate >= 7
      ? moment(dateTimeStart).format(FormatType["YYYY/M/D"])
      : moment(dateTimeStart).fromNow();
  };

  const [state, setState] = React.useState({
    time: date ? displayTime(date) : "",
  });

  React.useEffect(() => {
    // Set time display after each minute
    const refreshTimeComment = setInterval(() => {
      setState({
        ...state,
        time: date ? displayTime(date) : "",
      });
    }, 60000);

    return () => {
      clearInterval(refreshTimeComment);
    };
  }, []);

  return <div className={styles.time}>{state.time}</div>;
};

export default FromNow;
